import {Router} from 'ninelines-router';
import vars from './vars';
import transitions from './transitions';

history.scrollRestoration = 'manual';

let router = new Router();

router.addRoute({
	path: '/',
	name: 'main',
});

router.addRoute({
	path: '/article/:name',
	name: 'article',
});

router.addTransition({
	from: null,
	to: 'main',
	onEnter() {
		return transitions.goToMain();
	},
});

router.addTransition({
	from: null,
	to: 'article',
	onEnter(prevState, currentState) {
		return transitions.goToArticle(currentState.params.name);
	},
});

router.addTransition({
	from: 'main',
	to: 'article',
	onEnter(prevState, currentState) {
		return transitions.goFromMainToArticle(currentState.params.name);
	},
});

router.addTransition({
	from: 'article',
	to: 'main',
	onEnter() {
		return transitions.goFromArticleToMain();
	},
});

router.addTransition({
	from: 'article',
	to: 'article',
	onEnter(prevState, currentState) {
		return transitions.goFromArticleToArticle(currentState.params.name);
	},
});

router.on('leave', () => {
	return !vars.$html.hasClass('is-animating');
});

router.on('notFound', () => {
	document.location = '/';
});

router.start();

export default router;
